export default "__VITE_ASSET__YkOzDwxI__"